/* eslint-disable no-console */
// We import the CSS which is extracted to its own file by esbuild.
// Remove this line if you add a your own CSS build pipeline (e.g postcss).
// import "../css/app.css"

// If you want to use Phoenix channels, run `mix help phx.gen.channel`
// to get started and then uncomment the line below.
// import "./user_socket.js"

// You can include dependencies in two ways.
//
// The simplest option is to put them in assets/vendor and
// import them using relative paths:
//
//     import "../vendor/some-package.js"
//
// Alternatively, you can `npm install some-package --prefix assets` and import
// them using a path starting with the package name:
//
//     import "some-package"
//

// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
import 'phoenix_html'
// Establish Phoenix Socket and LiveView configuration.
import { Socket } from 'phoenix'
import { LiveSocket } from 'phoenix_live_view'
import LiveReact, { initLiveReact } from './vendor/phoenix_live_react'
import topbar from 'topbar'
import LiveSelect from './liveview_react/select'
import ListingPagePhotos from './liveview_react/listing_page_photos'
import LiveTimeRangeSlider from './liveview_react/time_range_slider'
import LiveAgeRangeSlider from './liveview_react/age_range_slider'
import LiveBudgetRangeSlider from './liveview_react/budget_range_slider'
import LiveNetworkAssessmentSlider from './liveview_react/network_assessment_slider'
import LiveSearchAnalytics from './liveview_react/live_search_analytics'
import LiveSexChart from './liveview_react/sex_chart'
import LiveRaceAndEthnicityChart from './liveview_react/race_and_ethnicity_chart'

import ParentMessagesSDK from './parent_messages_sdk_stub'
import * as CoreHooks from '../../../core_web/assets/js/hooks'

import '../css/app.css'
import flatpickr from 'flatpickr'
import loadTranslation from './flatpickr_locales/locale_resolver'

/* Top bar */

topbar.config({ barColors: { 0: '#29d' }, shadowColor: 'rgba(0, 0, 0, .3)' })

let topBarScheduled

window.addEventListener('phx:page-loading-start', () => {
  if (!topBarScheduled) {
    topBarScheduled = setTimeout(() => topbar.show(), 200)
  }
})

window.addEventListener('phx:page-loading-stop', () => {
  clearTimeout(topBarScheduled)
  topBarScheduled = undefined
  topbar.hide()
})

window.addEventListener('phx:redirect-on-parent', e => {
  if ('parentIFrame' in window) {
    window.parentIFrame.sendMessage({ type: 'redirect', to: e.detail.to, params: e.detail.params })
  }
})

window.addEventListener('phx:scroll-to-element', e => {
  const element = document.getElementById(e.detail.to)
  if (element) {
    element.scrollIntoView()
  }
})

function formatUSPhoneNumber(phoneNumber) {
  const sanitizedPhoneNumber = phoneNumber.replace('+1', '').replace(/\D/g, '')
  const phoneNumberPattern = /^(\d{1,3})?(\d{0,3})?(\d{0,4})?$/
  const matches = sanitizedPhoneNumber.match(phoneNumberPattern)

  if (!matches) return ''

  const [, areaCode, firstPart, secondPart] = matches

  let maskedNumber = ''
  if (areaCode) maskedNumber += `(${areaCode}`
  if (firstPart) maskedNumber += `) ${firstPart}`
  if (secondPart) maskedNumber += `-${secondPart}`

  return maskedNumber
}

/* Hooks */

const Hooks = { ...CoreHooks }

Hooks.LegacyReactLocaleLocalStorageHook = {
  mounted() {
    const localeOptions = this.el.querySelectorAll('.locale-option')

    localeOptions.forEach(option => {
      option.addEventListener('click', e => {
        const locale = e.target.dataset.locale

        if (locale) {
          localStorage.setItem('locale', locale)
        }
      })
    })
  },
}

Hooks.AnalyticsLiveSearch = {
  mounted() {
    window.liveView = this
  },
  updated() {
    const analyticsEvent = localStorage.getItem('analyticsEvent')
    const analyticsWriterId = localStorage.getItem('analyticsWriterId')
    const analyticsFilterChanged = localStorage.getItem('analyticsFilterChanged')

    if (
      analyticsEvent &&
      analyticsWriterId &&
      document.getElementById(analyticsWriterId).dataset.searchStatus === 'loaded'
    ) {
      LiveSearchAnalytics(analyticsEvent, analyticsWriterId, analyticsFilterChanged)
    }
  },
}

Hooks.GoogleMap = {
  mounted() {
    window.liveView = this
    window.saveMapView && window.saveMapView()
  },
  updated() {
    window.liveView = this

    window.updateMapMarkers && window.updateMapMarkers()
    window.saveMapView && window.saveMapView()
  },
}

Hooks.ParentMessages = {
  mounted() {
    window.liveView = this

    // # Configure and initialize the Parent Messages SDK

    // ## SDK -> LiveView
    //
    // Define callbacks to handle data sent from the SDK to LiveView
    const callbacks = {
      onConversationsLoad: data => {
        window.liveView.pushEvent('from-sdk.update-conversations', data)
      },
      onActiveConversationLoad: data => {
        window.liveView.pushEvent('from-sdk.update-active-conversation', data)
      },
      onSearchMessagesLoad: data => {
        window.liveView.pushEvent('from-sdk.update-search-messages', data)
      },
    }

    // ## Create the SDK instance
    //
    // This code assumes the Parent Messages SDK will require some
    // initial data to create the connection and fetch data.
    //
    // The initial data in this example is the `token` value. This is
    // defined on the server side. The LiveView instance takes this value
    // and passes it here through an HTML `data-*` attribute in the `.heex`
    // template. For example:
    //
    //    <div id="parent-messages" phx-hook="ParentMessages" data-token={@token}>
    //      ...
    //    </div>
    //
    const token = window.liveView.el.dataset.token

    window.parentMessagesSDKInstance = ParentMessagesSDK.init(token, callbacks)

    // ## LiveView -> SDK
    //
    // Define listeners to handle data sent from the LiveView to the SDK
    window.liveView.handleEvent('to-sdk.get-all-conversations', () => {
      window.parentMessagesSDKInstance.getAllConversations()
    })

    window.liveView.handleEvent('to-sdk.select-active-conversation', data => {
      window.parentMessagesSDKInstance.selectActiveConversation(data.id)
    })

    window.liveView.handleEvent('to-sdk.search-messages', data => {
      document.getElementById('search_messages_search').value = ''

      window.parentMessagesSDKInstance.searchMessages(data)
    })

    window.liveView.handleEvent('to-sdk.send-message', data => {
      document.getElementById('send_message_message').value = ''

      window.parentMessagesSDKInstance.sendMessage(data)
    })

    // ## Fetch data on mount
    //
    // Request some data from the SDK automatically when the LiveView mounts
    const activeConversationId = window.liveView.el.dataset.activeConversationId

    window.parentMessagesSDKInstance.getAllConversations()
    window.parentMessagesSDKInstance.selectActiveConversation(activeConversationId)
  },
}

Hooks.UserPreferenceSearchAsMapMoves = {
  // On mount, check if a previous cookie was set. If so, read the cookie value and
  // update the user preference in LiveView
  mounted() {
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('user_preference_search_as_map_moves='))
      ?.split('=')[1]

    if (cookieValue) {
      window.liveView.pushEvent('update-user-preference-search-as-map-moves', {
        'user-preference-search-as-map-moves': {
          enabled: `${cookieValue}`,
        },
      })
    }
  },
  // On update, read the updated value in LiveView, update the javascript
  // value, and persist the value in a cookie
  updated() {
    const value = document.getElementById('user-preference-search-as-map-moves').checked
    const weekInSeconds = 60 * 60 * 24 * 7

    document.cookie = `user_preference_search_as_map_moves=${value}; max-age=${weekInSeconds}`

    window.setUserPreferenceSearchAsMapMoves && window.setUserPreferenceSearchAsMapMoves(value)
  },
}

Hooks.OnboardingDisconnect = {
  disconnected() {
    if (window.onboarding.onDisconnect) {
      window.onboarding.handleDisconnect = setTimeout(
        window.onboarding.onDisconnect,
        window.onboarding.timeoutDisconnect,
      )
    }
  },
  reconnected() {
    if (window.onboarding) {
      if (window.onboarding.handleDisconnect) {
        window.onboarding.handleDisconnect = clearTimeout(window.onboarding.handleDisconnect)
      }

      if (window.onboarding.onConnect) {
        window.onboarding.onConnect()
      }
    }
  },
  mounted() {
    if (window.onboarding) {
      if (window.onboarding.handleDisconnect) {
        window.onboarding.handleDisconnect = clearTimeout(window.onboarding.handleDisconnect)
      }

      if (window.onboarding.onConnect) {
        window.onboarding.onConnect()
      }
    }
  },
}

Hooks.AsyncGoogleMap = {
  mounted() {
    const mapApiKey = this.el.dataset.mapApiKey
    const mapSource = `https://maps.googleapis.com/maps/api/js?key=${mapApiKey}&callback=initAsyncGoogleMap&v=weekly`
    const mapScript = document.createElement('script')

    const mapLatitude = parseFloat(this.el.dataset.mapLatitude)
    const mapLongitude = parseFloat(this.el.dataset.mapLongitude)

    window.liveView = this

    window.initAsyncGoogleMap = function initAsyncGoogleMap() {
      window.asyncGoogleMap = new window.google.maps.Map(
        document.getElementById('async-google-map'),
        {
          center: {
            lat: mapLatitude,
            lng: mapLongitude,
          },
          zoom: 14,
          streetViewControl: false,
          fullscreenControl: true,
          mapTypeControl: false,
        },
      )

      window.asyncGoogleMapMarker = new window.google.maps.Marker({
        position: {
          lat: mapLatitude,
          lng: mapLongitude,
        },
        map: window.asyncGoogleMap,
      })
    }

    mapScript.defer = true
    mapScript.setAttribute('src', mapSource)

    document.head.appendChild(mapScript)
  },
}

Hooks.RecommendationLocationInput = {
  mounted() {
    this.el.addEventListener('keydown', this.enterHandler.bind(this))
  },
  enterHandler(e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault()
      this.el.dispatchEvent(new Event('input', { bubbles: true }))
    }
  },
}

const USPhoneNumberMaskEventListener = ev => {
  const { target } = ev

  target.value = formatUSPhoneNumber(target.value)
}

Hooks.USPhoneNumberMask = {
  mounted() {
    this.el.addEventListener('input', USPhoneNumberMaskEventListener)
  },
  destroyed() {
    this.el.removeEventListener('input', USPhoneNumberMaskEventListener)
  },
}

Hooks.Flatpickr = {
  mounted() {
    const language = loadTranslation(this.el.dataset.language)
    this.flatpickr = flatpickr(this.el, { locale: language })
  },
}

Hooks.CopyToClipboard = {
  mounted() {
    const { to } = this.el.dataset
    this.el.addEventListener('click', ev => {
      ev.preventDefault()
      const text = document.querySelector(to).value
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          console.log('Copied value to clipboard:', text)
        })
      } else {
        console.log('Value not copied to clipboard. Must be connected through HTTPS:', text)
      }
    })
  },
}

Hooks.PreventEnterSubmit = {
  mounted() {
    this.el.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        e.preventDefault()
      }
    })
  },
}

Hooks.FilterOptions = {
  mounted() {
    this.options = Array.from(this.el.querySelector('[data-option-list]').children)
    this.query_el = this.el.querySelector('[data-query]')
    this.query_el.addEventListener('input', this.filterOptions.bind(this))
  },
  updated() {
    this.filterOptions()
  },
  filterOptions(_e) {
    const query = this.query_el.innerHTML.trim().toLowerCase()
    if (query.length === 0) {
      this.showAll()
    } else {
      this.hideFiltered(query)
    }
  },
  showAll() {
    this.options.forEach(optionEl => optionEl.classList.remove('hidden'))
  },
  hideFiltered(query) {
    this.options.forEach(optionEl => {
      if (optionEl.dataset.text.toLowerCase().includes(query)) {
        optionEl.classList.remove('hidden')
      } else {
        optionEl.classList.add('hidden')
      }
    })
  },
}

Hooks.Uncheck = {
  mounted() {
    this.target = document.getElementById(this.el.dataset.target)
    this.el.addEventListener('click', _e => {
      this.target.checked = false
      this.target.dispatchEvent(new Event('input', { bubbles: true }))
    })
  },
}

Hooks.OptionalTextInput = {
  mounted() {
    this.textInput = this.el.querySelector('input[type="text"]')
    this.checkbox = this.el.querySelector('input[type="checkbox"]')

    this.handleState()

    this.checkbox.addEventListener('change', _e => {
      if (this.checkbox.checked) {
        this.showTextInput()
      } else {
        this.hideTextInput()
      }
    })
  },
  showTextInput() {
    this.textInput.classList.remove('hidden')
  },
  handleState() {
    if (this.textInput.value.length > 0) {
      this.checkbox.checked = true
      this.showTextInput()
    }
  },
  hideTextInput() {
    this.textInput.value = ''
    this.textInput.dispatchEvent(new Event('blur', { bubbles: true }))
    this.textInput.classList.add('hidden')
  },
}

Hooks.TrackVisibility = {
  mounted() {
    window.liveView = this
    const targetId = this.el.dataset.target_id
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: [0.1],
    }

    const callback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.liveView.pushEventTo(`#${targetId}`, 'element-on-screen', {})
        } else {
          window.liveView.pushEventTo(`#${targetId}`, 'element-off-screen', {})
        }
      })
    }

    const observer = new IntersectionObserver(callback, options)

    const target = document.querySelector(`#${this.el.id}`)
    observer.observe(target)
  },
}

/* LiveView + React */

Hooks.LiveReact = LiveReact

// Don't change the variable name `e`. Unfortunately, `initLiveReact` looks for `e` to exist
// eslint-disable-next-line no-unused-vars
document.addEventListener('DOMContentLoaded', e => {
  initLiveReact()
})

window.LiveViewReactComponents = {
  LiveSelect,
  ListingPagePhotos,
  LiveTimeRangeSlider,
  LiveAgeRangeSlider,
  LiveBudgetRangeSlider,
  LiveNetworkAssessmentSlider,
  LiveRaceAndEthnicityChart,
  LiveSexChart,
}

/* Initialization */

const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute('content')
const metaToken = document.querySelector("meta[name='live-token']")
const liveToken = metaToken ? metaToken.getAttribute('content') : null
const path = liveToken ? '/headlessLive' : '/live'
const params = liveToken ? { _csrf_token: csrfToken, liveToken } : { _csrf_token: csrfToken }
const liveSocket = new LiveSocket(path, Socket, {
  params,
  hooks: Hooks,
  metadata: {
    click: (e, _el) => {
      return {
        event: {
          clientX: e.clientX,
          clientY: e.clientY,
          shiftKey: e.shiftKey,
        },
      }
    },
  },
})

// Show progress bar on live navigation and form submits
// topbar.config({barColors: {0: "#29d"}, shadowColor: "rgba(0, 0, 0, .3)"})
// window.addEventListener("phx:page-loading-start", info => topbar.show())
// window.addEventListener("phx:page-loading-stop", info => topbar.hide())

// connect if there are any LiveViews on the page
liveSocket.connect()

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket
